import Translations from "@translate/componentsv1/radar/consts/themes";
import { I18nUtil } from "@utils/i18n";

// TODO ZJL DO 删除 主题图片基础路径与目录名（公共常量）
const STATIC_IMG_BASE = "https://static.edwealth.ai/images";
const CRYPTO_THEMES_DIR = "crypto-themes-v2";
const IMG_SUFFIX = ".png";

export const DEAULT_US_STOCK_THEME_SLUG = "trending";
export const DEAULT_HK_STOCK_THEME_SLUG = "trending";
export const HOT_US_STOCK_THEME_SLUG = "artificial-intelligence";
export const HOT_HK_STOCK_THEME_SLUG = "cloud-computing";

export const CRYPTO_THEME_LABELS = {
  blueChip: "blue-chip-tokens",
} as const;

export const PRICE_CHANGE_24H_THEMES = [
  "binance-listing-(perp-spot)",
  "upbit-listing",
  "coinbase-listing",
  "okx-listing",
  "bithumb-listing",
  "bybit-listing",
] as string[];

// TODO ZJL DO 保留
export const radarCryptoDomain = {
  cryptoMindshare: "crypto-mindshare",
  justFundraised: "just-fundraised",
  dexTracker: "dex-tracker",
  trending: "trending",
} as const;
export type RadarCryptoDomain_TYPE =
  (typeof radarCryptoDomain)[keyof typeof radarCryptoDomain];

export const getStockTrendingTheme = (locale: string) => {
  const I18n = I18nUtil.createScoped(Translations, locale);
  return {
    icon: "Trending",
    value: I18n.t("Trending"),
    label: radarCryptoDomain.trending,
    image: `${STATIC_IMG_BASE}/${CRYPTO_THEMES_DIR}/Trending${IMG_SUFFIX}`,
    title: I18n.t("Trending"),
    seoText: I18n.t("Trending"),
    desc: I18n.t("Trending"),
  };
};
// TODO ZJL DO 保留
export const getCrypto_MainPage_TABS = (locale?: string) => {
  const GlobalI18n = I18nUtil.createScoped(Translations, locale);
  const I18n = GlobalI18n;
  return [
    {
      icon: "twitter",
      value: I18n.t("Crypto Mindshare"),
      label: radarCryptoDomain.cryptoMindshare,
      image: `${STATIC_IMG_BASE}/${CRYPTO_THEMES_DIR}/crypto-mindshare${IMG_SUFFIX}`,
      seoText: I18n.t("Crypto Mindshares: What’s Trending in the Market"),
      desc: I18n.t(
        "The amount of public attention, awareness, and discussion a particular cryptocurrency project, brand, or idea commands within the crypto community and among the general public. It's a measure of a project's visibility and its ability to occupy the \"mental space\" of its target audience.",
      ),
    },
    {
      icon: "Fundraised",
      value: I18n.t("Just Fundraised"),
      label: radarCryptoDomain.justFundraised,
      image: `${STATIC_IMG_BASE}/${CRYPTO_THEMES_DIR}/just-fundraised${IMG_SUFFIX}`,
      seoText: I18n.t("Just Fundraised: Emerging Crypto Projects to Watch"),
      desc: I18n.t(
        "Refers to cryptocurrency projects or startups that have recently secured capital through various funding methods.",
      ),
    },
    {
      icon: "Trending",
      value: I18n.t("DEX Tracker"),
      label: radarCryptoDomain.dexTracker,
      image: `${STATIC_IMG_BASE}/${CRYPTO_THEMES_DIR}/dex-tracker${IMG_SUFFIX}`,
      seoText: I18n.t("Meme Coins: Catch the Hype with Edgen Radar"),
      desc: I18n.t(
        "Decentralized Exchange (DEX) Tracker Tool is a specialized data analytics platform that provides real-time information and insights into the trading activity on decentralized exchanges.",
      ),
    },
  ];
};
